import { IApplicationState } from '../../types/redux';

export function getFlatViewOrderDetails(state: IApplicationState): string {
  const { newbuilding } = state;

  return newbuilding?.flatViewOrder?.orderStatus?.description || 'Вы записались на просмотр квартиры в данном ЖК!';
}
